import * as React from 'react'

import AnsiText from './AnsiText/AnsiText'
import LinkText from './LinkText/LinkText'

type Props = {
  text: string
  parseLinks?: boolean | null | undefined
  parseAnsi?: boolean | null | undefined
}

function LogMessageText({text, parseLinks, parseAnsi}: Props) {
  if (parseAnsi === true) {
    return <AnsiText parseLinks={parseLinks}>{text}</AnsiText>
  }

  if (parseLinks === true) {
    return <LinkText>{text}</LinkText>
  }

  return <>{text}</>
}

export default React.memo<Props>(LogMessageText)
